import Axios from 'axios'
import React, {useEffect, useState} from 'react'
import config from '../config/config'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiFormLabel-root": {
            lineHeight: 0
        },
    },
    inputRoot: {
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
            padding: 0
        },
        '& .MuiAutocomplete-endAdornment': {
            display: 'none'
        },
    }
}));
const Currentopening = () => {
    const [job, setJob] = useState(null)
    const [showOpenings, setShowOpenings] = useState(false)
    const [selectedMember, setSelectedMember] = useState();
    const [myOptions, setMyOptions] = useState([])
    const [inputText, setInputText] = useState("");
    const classes = useStyles();


    useEffect(() => {
        Axios.get(`${config.getJobUrl}`)
            .then((response) => {
                setJob(response.data)
                if (response.data.length > 0) {
                    setShowOpenings(true)
                }
            }).catch((error) => {
            setShowOpenings(false)
        });
    }, [])

    if (!job) {
        return null;
    }

    const filteredData = job.filter((el) => {
        if (inputText === '') {
            return el;
        } else if ((el.job_description.role.toLowerCase().includes(inputText.toLowerCase()))) {
            return el;
        }
    })

    return (
        <section id="services" className="services career-title">
            <div className="container" data-aos="fade-up" id="cards">
                <div className="row">
                    <div className="col-lg-8 col-sm-8 col-xs-8 job-description-title">
                        <h3 className='currentOpening'>Current Openings</h3>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4 job-description-title">
                        <Autocomplete className='searchbar'
                                      freeSolo
                                      autoComplete
                                      autoHighlight
                                      options={myOptions}
                                      classes={classes}
                                      renderInput={(params) => (
                                          <TextField {...params}
                                                     onChange={event => setInputText(event.target.value)}
                                                     variant="outlined"
                                                     label="Search Openings"
                                          />
                                      )}
                        />

                    </div>

                </div>
            </div>

            <section id="services" className="services career-title">
                {
                    showOpenings ? <section id="services" className="services">
                        <div className="container">
                            <div className="mgt-40 relative ultab right_app_text d-none d-md-block d-lg-block">

                                <div className="row current-opening-job-align">
                                    <div className="col-lg-3 col-md-3 col-sm-3 current-opening-job-align">
                                        <div className="current-opening-job">

                                            <h3>Title</h3>

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 current-opening-job-align">
                                        <div className=" current-opening-job">
                                            <h3>Location</h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 current-opening-job-align">
                                        <div className="current-opening-job">
                                            <h3>Type</h3>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </div>

                    </section> : ""
                }
                {showOpenings ? filteredData.map((ele, index) => {
                    return (
                        <section id="services" className="services" key={index}>
                            <div className="container" data-aos="fade-up">
                                <div className="row current-opening-job-align">
                                    <div className="col-lg-3 col-md-3  current-opening-job-align" data-aos="zoom-in"
                                         data-aos-delay="100">
                                        <div className="current-opening-job">
                                            <a className="job-card-main-content__item" href={"/job/" + ele.job_ID}
                                               id={ele._id} onClick={() => {
                                                setSelectedMember(ele);
                                            }}>
                                                <h5>{ele.job_description.role}</h5>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3  current-opening-job-align" data-aos="zoom-in"
                                         data-aos-delay="200">
                                        <div className=" current-opening-job">
                                            <p className='current-opening-job'>{ele.location}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3  current-opening-job-align" data-aos="zoom-in"
                                         data-aos-delay="300">
                                        <div className="current-opening-job">
                                            <p className='current-opening-job'>{ele.job_description.employment_type}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3  current-opening-job-align" data-aos="zoom-in"
                                         data-aos-delay="300">
                                        <div className="apply-btn current-opening-job">
                                            <a className="job-card-main-content__item" href={"/job/" + ele.job_ID}
                                               id={ele._id} onClick={() => {
                                                setSelectedMember(ele);
                                            }}>
                                                <button className='job-apply-btn current-opening-job'>Apply</button>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </section>
                    )
                }) : <h4 className="text-center">No Current Openings</h4>}

            </section>
        </section>
    )
}

export default Currentopening



// WEBPACK FOOTER //
// ./src/components/Currentopening.js